import React from 'react'
import {Form, Icon, Input, Checkbox, Radio, Select} from 'antd';

import PatientElectronicText from './Texts/PatientElectronicText';
import SurrogateElectronicText from './Texts/SurrogateElectronicText';
import Signature from "./Signature";

const { Option } = Select;

export default class extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;

    const isEmail = props.consentMethodType === 'Email';
    const showForEmail = !(props.consentMethodType === 'Email' && !props.token);

    return (
      <div className="form-group">
        <h4>{props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'}</h4>

        <div className="form-group-details">
          {props.siteID && <h5>Site ID: <b>{props.siteID}</b></h5>}
          {props.userID && <h5>User ID: <b>{props.userID}</b></h5>}
          <h5>Subject ID: <b>{props.subjectID}</b></h5>
        </div>

        {props.consentPersonType === 'Surrogate' ? <SurrogateElectronicText {...props} /> :
          <PatientElectronicText {...props} />}

        <p><strong>Server Date (UTC): {props.date || props.consentDate}</strong></p>
        <p><strong>Consent Type: {props.consentPersonType}</strong></p>
        <p><strong>Consent Method: {props.consentMethodType}</strong></p>
        <p>&nbsp;</p>

        <h4>DOCUMENTATION OF INFORMED CONSENT</h4>

        <div style={{ textAlign: 'left' }}>

          {showForEmail && <div>
            <p>You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.</p>
            <Form.Item>
              <label>
                <div className='form-label'>Please check the appropriate box to indicate your decision:</div>
                {props.form.getFieldDecorator('sb_dic_consent_option', {
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group>
                    <Radio value='stay_in_study'>
                      I wish to stay in the study.
                    </Radio>
                    <br/>
                    <Radio value='withdraw_from_study'>
                      I wish to withdraw from the study
                    </Radio>
                    <br/>
                    <Radio value='withdraw_from_study_allow_data_collection_via_linkage'>
                      I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>
          </div>}
          <br/><br/>

          <h4>SIGNATURES</h4>
          {showForEmail && <div>
            <p>All of my questions have been answered,</p>

            <p>
              I understand the information within this informed consent form, <br/>
              I allow access to medical records and related personal health information as explained in this consent form,<br/>
              I do not give up any legal rights by signing this consent form,<br/>
              I understand that my family doctor/health care provider will be informed of study participation<br/>
              I agree, or agree to allow the person I am responsible for, to take part in this study.
            </p>
            <br/><br/>
          </div>}


          <Form.Item>
            <label>
              <div className='form-label'>Participant Name</div>
              {props.form.getFieldDecorator('sb_dic_research_subject_name', {
                initialValue: props.sb_dic_research_subject_name,
                rules: [{
                  required: true,
                  message: 'Required'
                }],
              })(
                <Input
                  prefix={<Icon type="user" style={{color: '#eee'}}/>}
                  placeholder="Participant Name"
                />
              )}
            </label>
          </Form.Item>

          {props.consentMethodType === 'Email' && props.consentPersonType === 'Surrogate' &&
          <Form.Item>
            <label>
              <div className='form-label'>Substitute Decision Maker</div>
                {props.form.getFieldDecorator('sb_dic_participant_email', {
                  initialValue: props.sb_dic_participant_email,
                  rules: [{required: true, message: 'Please enter the SDM\'s email'}, {type: 'email'}],
                })(
                  <Input disabled={props.token} placeholder="Substitute Decision Maker Email"/>
                )}
            </label>
          </Form.Item>}
          {props.consentMethodType === 'Email' && props.consentPersonType === 'Patient' &&
          <Form.Item>
            <label>
              <div className='form-label'>Participant Email</div>
                {props.form.getFieldDecorator('sb_dic_participant_email', {
                  initialValue: props.sb_dic_participant_email,
                  rules: [{required: true, message: 'Please enter the participant\'s email'}, {type: 'email'}],
                })(
                  <Input disabled={props.token} placeholder="Participant Email"/>
                )}
            </label>
          </Form.Item>}

          {props.consentPersonType === 'Patient' && showForEmail  && (
            <div>
              <Signature fieldName='sb_dic_research_subject_signature' label='Signature of Participant' form={props.form} />
            </div>
          )}

          {props.consentPersonType === 'Surrogate' && <div>
            <Form.Item>
              <label>
                <div className='form-label'>Substitute Decision-Maker Name</div>
                {props.form.getFieldDecorator('sb_dic_surrogate_name', {
                  initialValue: props.sb_dic_surrogate_name,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Input
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Substitute Decision-Maker Name"
                  />
                )}
              </label>
            </Form.Item>

            {showForEmail && <Signature fieldName='sb_dic_surrogate_signature' label='Signature of Substitute Decision-Maker' form={props.form} />}
          </div>}

          <div>
            <Form.Item>
              <label>
                <div className='form-label'>Person Conducting the Consent Discussion Name & Role</div>
                {props.form.getFieldDecorator('sb_dic_investigator_name_and_role', {
                  initialValue: props.sb_dic_investigator_name_and_role,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Input
                    disabled={props.token}
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Name & Role"
                  />
                )}
              </label>
            </Form.Item>

            {!props.token && <Signature fieldName='sb_dic_investigator_signature' label='Signature of Person Conducting the Consent Discussion' form={props.form} />}
          </div>


          {showForEmail && <div>

            <p>The following attestation must be provided if the participant is unable to read or requires an oral translation:</p>
            <p><b>If the participant is assisted during the consent process, please check the relevant box and complete the signature space below:</b></p>

            <Form.Item>
              {props.form.getFieldDecorator('sb_dic_is_interpreter', {
                initialValue: false,
                valuePropName: 'checked',
              })(
                <Checkbox>The person signing below acted as an interpreter, and attests that the study as set out in the consent form was accurately sight translated and/or interpreted, and that interpretation was provided on questions, responses and additional discussion arising from this process.</Checkbox>
              )}
            </Form.Item>


            {props.form.getFieldValue('sb_dic_is_interpreter') && <div>
              <Form.Item>
                <label>
                  <div className='form-label'>Interpreter Name</div>
                  {props.form.getFieldDecorator('sb_dic_interpreter_name', {
                    initialValue: props.sb_dic_interpreter_name,
                    rules: [{
                      required: true,
                      message: 'Required'
                    }],
                  })(
                    <Input
                      prefix={<Icon type="user" style={{color: '#eee'}}/>}
                      placeholder="Interpreter Name"
                    />
                  )}
                </label>
              </Form.Item>

              <Signature fieldName='sb_dic_interpreter_signature' label='Signature of Interpreter' form={props.form} />

              <Form.Item>
                <label>
                  <div className='form-label'>Interpreter Language</div>
                  {props.form.getFieldDecorator('sb_dic_interpreter_language', {
                    initialValue: props.sb_dic_interpreter_language,
                    rules: [{
                      required: true,
                      message: 'Required'
                    }],
                  })(
                    <Input
                      placeholder="Interpreter Language"
                    />
                  )}
                </label>
              </Form.Item>
            </div>}

            {!isEmail && <Form.Item>
              {props.form.getFieldDecorator('sb_dic_interpreter_was_read', {
                initialValue: false,
                valuePropName: 'checked',
                rules: [{
                  required: false,
                  transform: value => (value || undefined),
                  type: 'boolean',
                  message: 'Required'
                }],
              })(
                <Checkbox>The consent form was read to the participant. The person signing below attests that the study as set out in this form was accurately explained to the participant, and any questions have been answered.</Checkbox>
              )}
            </Form.Item>}

            {!isEmail && props.form.getFieldValue('sb_dic_interpreter_was_read') && <div>
              <Form.Item>
                <label>
                  <div className='form-label'>Witness Name</div>
                  {props.form.getFieldDecorator('sb_dic_witness_name', {
                    initialValue: props.sb_dic_witness_name,
                    rules: [{
                      required: !props.token,
                      message: 'Required'
                    }],
                  })(
                    <Input
                      prefix={<Icon type="user" style={{color: '#eee'}}/>}
                      placeholder="Witness Name"
                    />
                  )}
                </label>
              </Form.Item>

              <Signature fieldName='sb_dic_witness_signature' label='Signature of Witness' form={props.form} optional={props.token} />

              <Form.Item>
                <label>
                  <div className='form-label'>Relationship to Participant</div>
                  {props.form.getFieldDecorator('sb_dic_witness_relationship', {
                    initialValue: props.sb_dic_witness_relationship,
                    rules: [{
                      required: !props.token,
                      message: 'Required'
                    }],
                  })(
                    <Input
                      placeholder="Relationship to Participant"
                    />
                  )}
                </label>
              </Form.Item>
            </div>}
            <br/>
            <br/>

            <h3>DEFERRAL OF CONSENT SUB-STUDY</h3>
            <p>We’d like to ask you a few survey questions about how you feel about this study and having been a part of it. The purpose of the survey is to capture the attitudes and experience of participants/SDMs with the deferral of consent process used in the study. This survey is optional. You do not have to take part in the survey to be a part of the main study.</p>

            <p>Please check the appropriate box to indicate your decision:</p>

            <Form.Item>
              <label>
                <div className='form-label'>Please check the appropriate box to indicate your decision:</div>
                {props.form.getFieldDecorator('sb_dcss_option', {
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group>
                    <Radio value='yes'>
                      I wish to take part in the survey.
                    </Radio>
                    <br/>
                    <Radio value='no'>
                      I wish NOT to take part in the survey.
                    </Radio>
                    <br/>
                    <Radio value='not_applicable'>
                      Not applicable (site is not participating in the ethics survey)
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>

            <Form.Item>
              <label>
                <div className='form-label'>Do you consent to the terms described above?</div>
                {props.form.getFieldDecorator('consent_provided', {
                  initialValue: props.consent_provided,
                  rules: [{
                    required: true,
                    message: 'Do you consent to the terms described above?'
                  }],
                })(
                  <Select>
                    <Option value="yes">Yes</Option>
                    <Option value="">No</Option>
                  </Select>
                )}
              </label>
            </Form.Item>
          </div>}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeOttawa/Step3aPatient.js